import { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';

import Box from '@mui/material/Box';
import AddIcon from '@mui/icons-material/Add';
import { SCUIButton } from '../../../../../../atomic/atoms';
import { CriteriaTypeGrid, CriteriaTypeModal } from './components';
import { CTT } from './criteriaTypeTab.classes';

export const CriteriaTypeTab: FC<any> = () => {
    const [isModalOpen, setIsModalOpen] = useState<boolean>(false);

    const { t } = useTranslation();

    return (
        <>
            <Box className={CTT.root} sx={{ padding: '16px' }}>
                <SCUIButton
                    className={CTT.createButton}
                    showStartIcon
                    startIcon={<AddIcon style={{ color: 'white' }} />}
                    text={t('ruleManagement.createNewCriteriaTypeV2')}
                    type="primary"
                    sizeType="fixed"
                    size={'m'}
                    onClick={() => {
                        setIsModalOpen(true);
                    }}
                />
                <Box className={CTT.gridSection} sx={{ paddingTop: '16px' }}>
                    <CriteriaTypeGrid />
                </Box>
            </Box>
            <div className={CTT.modalSection}>
                <CriteriaTypeModal isModalOpen={isModalOpen} setIsModalOpen={setIsModalOpen} />
            </div>
        </>
    );
};
